import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { storageService } from '../api';
import { useAuth } from '../context/AuthContext';

/**
 * Shared hook for uploading images from RichTextEditor to temp blob storage.
 * Returns a callback that uploads a file and returns a signed download URL.
 * Backend moves temp blobs to permanent storage on save.
 *
 * @param {number | null} [organizationId] - Override org for SuperAdmin uploads
 * @returns {(file: File) => Promise<string | null>}
 */
export const useEditorImageUpload = (organizationId = null) => {
  const { user } = useAuth();

  return useCallback(async (file) => {
    try {
      const { blobPath } = await storageService.uploadFileToBlob(file);
      const result = await storageService.getDownloadUrl(blobPath, 60, organizationId);
      return result?.downloadUrl || null;
    } catch (err) {
      console.error('Editor image upload failed:', err);
      toast.error('Failed to upload image');
      return null;
    }
  }, [organizationId]);
};
